import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-readonly-attr-template',
  templateUrl: './readonly-attr-template.component.html',
  styleUrls: ['./readonly-attr-template.component.scss']
})
export class ReadonlyAttrTemplateComponent implements OnInit {
  @Input() attrs: any;
  checked: boolean = false;
  constructor() { }

  ngOnInit() {
    if (this.attrs.type === 'switch') {
      //console.log(this.attrs.value);
      if (this.attrs.value && this.attrs.value.toUpperCase() === 'TRUE') {
        this.checked = true;
      }
      else { this.checked = false; }
    }
  }

}
